import React from "react";

import { useAuth } from "../../services/authentication/authentication.context";
import { formatUrl } from "../../helpers/parse-url";

export const ProfileCard = () => {

    const { userData } = useAuth();

    return (
        <div className="question-form">
            <div className="image-container">
                <img
                    className="profile-iage"
                    src={
                       
                            userData?.avatar ? 
                            formatUrl(userData?.avatar) :
                            "/media/peer.png"
                        
                    }
                    alt="" 
                    width={100}
                    height={100}
                />
            </div>
            <div className="input-container">
                <span className="input-cap">Names</span>
                <input 
                    type="text" 
                    value={userData?.names } 
                    className="input"
                    placeholder="Enter your full names"
                    disabled 
                />
            </div>
            <div className="input-container">
                <span className="input-cap">Username</span>
                <input 
                    type="text" 
                    value={userData?.username } 
                    className="input"
                    placeholder="Enter your full names"
                    disabled
                />
            </div>
            <div className="input-container">
                <span className="input-cap">Phone Number</span>
                <input 
                    type="tel" 
                    value={userData?.phoneNumber } 
                    className="input"
                    placeholder="your phone number with area code"
                    disabled 
                />
            </div>
            <div className="input-container">
                <span className="input-cap">bio</span>
                <textarea
                    className="input"
                    cols={10}
                    rows={10} 
                    placeholder="say something about yourself"
                    disabled
                    value={userData?.biodata}
                >

                </textarea>
            </div>
        </div>
    );
}